import { styled } from '@mui/material';
import Checkbox from '../../../../components/v2/form/Checkbox/Checkbox';

export type CatalogCardCheckboxProps = {
  isSelected: boolean;
  isAnySelected: boolean;
  onToggleSelect: () => void;
};

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: theme.spacing(1),
  zIndex: 1,
}));

const CatalogCardCheckbox = ({
  isSelected,
  isAnySelected,
  onToggleSelect,
}: CatalogCardCheckboxProps) => {
  return (
    <StyledCheckbox
      className="catalog-card-checkbox"
      checked={isSelected}
      onClick={(e) => {
        e.stopPropagation();
        onToggleSelect();
      }}
      sx={
        isAnySelected ? { opacity: '1 !important', display: 'inline-block' } : { display: 'none' }
      }
    />
  );
};

export default CatalogCardCheckbox;
